import Cookie from 'js-cookie';

export const setCookies = (name: string, value: string) => {
  Cookie.set(name, value, { expires: 90 });
};

export const getCookies = (name: string) => {
  return Cookie.get(name);
};
